import styled from 'styled-components';

export const Link = styled.a`
  position: fixed;
  top: ${({ theme }) => theme.spacing[4]};
  left: ${({ theme }) => theme.spacing[4]};
  z-index: ${({ theme }) => theme.zIndex.max};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme }) => theme.semantic.brand.accent};
  color: ${({ theme }) => theme.colors.navy[900]};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  text-decoration: none;

  /* Visível apenas no foco via teclado */
  transform: translateY(-200%);
  transition: transform 0.2s ease;

  &:focus {
    transform: translateY(0);
  }
`;
